"use strict";

(function (Drupal) {
  Drupal.behaviors.dart_utils = {
    attach: function attach(context) {},
    /**
     * Body prevent scroll
     * Prevents body overscroll when modals are open.
     * By our very own Brian Harrington: https://codepen.io/brianharrington/pen/PozBGBg
     */
    body_prevent_scroll: function body_prevent_scroll() {
      var scrollY = window.scrollY;
      document.body.classList.add('no-scroll');
      document.body.style.top = "-".concat(scrollY, "px");
    },
    /**
     * Body prevent scroll destroy
     * Resets the position of previous scroll location.
     */
    body_prevent_scroll_destroy: function body_prevent_scroll_destroy() {
      var scrollY = document.body.style.top;
      document.body.classList.remove('no-scroll');
      document.body.style.top = '';
      window.scrollTo(0, parseInt(scrollY || '0') * -1);
    },
    /**
     * Convert Hex to RGB.
     * @param {string} hex a hex value.
     */
    hexToRgb: function hexToRgb(hex) {
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    },
    /**
     * Load a YouTube video using the YouTube IFrame player API
     * or a Vimeo video using the Vimeo Player SDK.
     * @param {element} hero The hero element.
     */
    loadHeroVideo: function loadHeroVideo(hero) {
      var embed = hero.querySelector('.video--embed');
      var poster = hero.querySelector('.video--poster');
      var pauseButton = hero.querySelector('.button--pause');
      var fallback = hero.querySelector('.fallback');
      var url = embed.getAttribute('data-media-url');
      var id;
      var classes = {
        paused: 'js-video-is-paused',
        playing: 'js-video-is-playing'
      };
      switch (embed.getAttribute('data-provider')) {
        case 'youtube':
          var player;
          id = url.split('?v=')[1];
          // Load the IFrame Player API code asynchronously.
          // This prevents us from having to do setInterval().
          var tag = document.createElement('script');
          tag.src = 'https://www.youtube.com/player_api';
          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

          // The magic combo of player options to allow for autoplay/loop/bg video goodness.
          var playerOptions = {
            autoplay: 0,
            mute: 1,
            autohide: 1,
            modestbranding: 1,
            rel: 0,
            showinfo: 0,
            controls: 0,
            disablekb: 1,
            enablejsapi: 1,
            iv_load_policy: 3,
            loop: 1,
            playlist: id
          };

          // We don't attempt to load the player until the YouTube API is ready.
          // This is a function wrapper YouTube provides. We just drop our player config in there.
          window.onYouTubePlayerAPIReady = function () {
            player = new YT.Player(embed, {
              videoId: id,
              playerVars: playerOptions,
              events: {
                onReady: onPlayerReady
              }
            });
          };
          function onPlayerReady(event) {
            var tl = new TimelineMax({
              onStart: function onStart() {
                event.target.playVideo();
              }
            });
            tl.to(poster, 0.75, {
              opacity: 0
            });
          }

          // @TODO – make this a separate function.
          pauseButton.addEventListener('click', function () {
            if (pauseButton.classList.contains(classes.playing)) {
              player.pauseVideo();
              pauseButton.classList.remove(classes.playing);
              pauseButton.classList.add(classes.paused);
            } else {
              player.playVideo();
              pauseButton.classList.remove(classes.paused);
              pauseButton.classList.add(classes.playing);
            }
          });
          break;
        case 'vimeo':
          id = /[^/]*$/.exec(url)[0];
          var vimeoPlayer = new Vimeo.Player(embed, {
            id: id,
            autoplay: 0,
            loop: true,
            controls: false,
            muted: true,
            width: 1920,
            height: 1080,
            quality: '1080p',
            playsinline: 1
          });
          function pauseButtonEvents(pauseButton) {
            pauseButton.addEventListener('click', function () {
              if (pauseButton.classList.contains(classes.playing)) {
                vimeoPlayer.pause();
                pauseButton.classList.remove(classes.playing);
                pauseButton.classList.add(classes.paused);
              } else {
                vimeoPlayer.play();
                pauseButton.classList.remove(classes.paused);
                pauseButton.classList.add(classes.playing);
                if (jQuery(".fallback").css('opacity') === '1') {
                  jQuery('.fallback').fadeOut("slow");
                }
              }
            });
          }
          vimeoPlayer.ready().then(function () {
            var errorMark;
            var tl = new TimelineMax({
              onStart: function onStart() {
                var video = vimeoPlayer.play();
                video.catch(function (error) {
                  errorMark = true;
                  console.log(error);
                });
              },
              onUpdate: function onUpdate() {
                if (errorMark === true) {
                  pauseButton.classList.remove(classes.playing);
                  pauseButton.classList.add(classes.paused);
                  jQuery(".fallback").css('opacity', '1');
                }
              },
              onComplete: function onComplete() {
                if (errorMark === true) {
                  pauseButton.classList.remove(classes.playing);
                  pauseButton.classList.add(classes.paused);
                  jQuery(".fallback").css('opacity', '1');
                }
              }
            });
            setTimeout(function () {
              tl.to(fallback, 1.25, {
                opacity: 0
              });
            }, 1000);
            pauseButtonEvents(pauseButton);
          }).catch(function (error) {
            return console.error(error);
          });
          break;
      }
    },
    /**
     * Load a progress bar for a carousel.
     * @param {element} progressBar The progress bar element.
     * @param {object} timeline The GSAP timeline for the progress bar.
     */
    loadProgressBar: function loadProgressBar(progressBar, timeline) {
      var progressPercentage = progressBar.querySelector('.progress-bar--percentage');
      timeline.to(progressPercentage, {
        width: '100%',
        ease: 'linear',
        duration: 10
      });
    },
    /**
     * Reset progress bar for a carousel.
     * @param {object} timeline The GSAP timeline for the progress bar.
     */
    resetProgressBar: function resetProgressBar(timeline) {
      timeline.restart();
    },
    /**
     * Kill progress bar for a carousel.
     * @param {object} timeline The GSAP timeline for the progress bar.
     */
    killProgressBar: function killProgressBar(timeline) {
      timeline.kill();
    },
    /**
     * Increment a pager for a carousel.
     * @param {element} pager The pager element.
     * @param {integer} slideCount The number of slides in the carousel.
     * @param {boolean} reverse if the pager should be reversed.
     */
    incrementPager: function incrementPager(pager, slideCount, reverse) {
      // The current page starts at "1" and we need to increment from there.
      var currentPage = pager.querySelector('.current-page');
      var pageTxt = parseInt(currentPage.textContent);
      if (reverse) {
        if (pageTxt > 1) {
          currentPage.textContent = pageTxt - 1;
        } else {
          // Otherwise we're back at the beginning.
          currentPage.textContent = slideCount;
        }
        return;
      }

      // We turn the text content into an integer and increment it based on where we are
      // in the slideshow.
      // If we're less than total the count of slides, increase by one.
      if (!reverse && pageTxt < slideCount) {
        currentPage.textContent = pageTxt + 1;
      } else {
        // Otherwise we're back at the beginning.
        currentPage.textContent = 1;
      }
    },
    /**
     * Wait for dynamic element to exist.
     *
     * @param {string} The query selector.
     * @param {function} The callback function.
     * @param {number} How often to poll, in millisecond.
     * @param {number} Max milliseconds this can run.
     */
    waitForElementToDisplay: function waitForElementToDisplay(selector, callback, checkFrequencyInMs, timeoutInMs) {
      var startTimeInMs = Date.now();
      (function loopSearch() {
        var elem = document.querySelector(selector);
        if (elem != null) {
          callback(elem);
          return;
        } else {
          setTimeout(function () {
            if (timeoutInMs && Date.now() - startTimeInMs > timeoutInMs) {
              return;
            }
            loopSearch();
          }, checkFrequencyInMs);
        }
      })();
    },
    /**
     * Check if script already exsits.
     * @param {string} The script url.
     * @return {bool}
     */
    scriptAlreadyExists: function scriptAlreadyExists(url) {
      if (!url) {
        return false;
      }
      var scripts = document.getElementsByTagName('script');
      for (var i = scripts.length; i--;) {
        if (scripts[i].src === url) {
          return true;
        }
      }
      return false;
    },
    /**
     * Get query string param by name.
     * @param {string} The query param.
     * @return {mixed}
     */
    getParameterByName: function getParameterByName(name) {
      name = name.replace(/[\[\]]/g, '\\$&');
      var url = window.location.href;
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
      var results = regex.exec(url);
      if (!results) {
        return null;
      }
      if (!results[2]) {
        return '';
      }
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
  };
})(Drupal);